"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterLink = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const LegacyFooterLink_1 = require("./LegacyFooterLink");
const SwappableFooterLink_1 = require("./SwappableFooterLink");
const Text_atom_1 = require("../Text.atom");
const ArrowIconSvg_atom_1 = require("../ArrowIconSvg.atom");
const classnames_1 = __importDefault(require("classnames"));
const UnstyledFooterLink = (_a) => {
    var { title, arrowIcon, className } = _a, props = __rest(_a, ["title", "arrowIcon", "className"]);
    const isLegacyBehaviour = (0, epic_games_nav_shared_1.useLegacyLinkBehaviour)();
    const children = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Text_atom_1.Text, null, title),
        arrowIcon ? react_1.default.createElement(ArrowIconSvg_atom_1.ArrowIconSvg, { face: "upright" }) : null));
    const classes = (0, classnames_1.default)(className, 'footer-link');
    if (isLegacyBehaviour) {
        return (react_1.default.createElement(LegacyFooterLink_1.LegacyFooterLink, Object.assign({ className: classes }, props), children));
    }
    return (react_1.default.createElement(SwappableFooterLink_1.SwappableFooterLink, Object.assign({ className: classes }, props), children));
};
exports.FooterLink = (0, styled_components_1.default)(UnstyledFooterLink) `
    padding: 0 12px 8px;
    display: inline-block;
    transition: color 0.3s ${(p) => p.theme.easing};
    .footer-text {
        line-height: 22px;
    }
    .arrow-wrap {
        svg path {
            transition: fill 0.3s ${(p) => p.theme.easing};
            fill: ${(p) => p.theme.palette.accent.text};
        }
    }
    &:hover {
        color: ${(p) => p.theme.palette.text.primaryHover};
        text-decoration: none;
        .arrow-wrap {
            transform: translate3d(0, 0, 0) translateX(1px) translateY(-1px);
            svg path {
                fill: ${(p) => p.theme.palette.text.primaryHover};
            }
        }
    }
`;
//# sourceMappingURL=Footerlink.js.map